import { render, staticRenderFns } from "./GlButton.vue?vue&type=template&id=d521cebc&scoped=true&"
import script from "./GlButton.vue?vue&type=script&lang=js&"
export * from "./GlButton.vue?vue&type=script&lang=js&"
import style0 from "./GlButton.vue?vue&type=style&index=0&id=d521cebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d521cebc",
  null
  
)

export default component.exports